export default "__VITE_ASSET__B4wkW1fC__"